import { IAPIRoutes } from "../../../../config";

export const ReportRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}): IReportRepository => {
  const { GET, PUT } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getDailyReportList: IGetDailyReportListApi = async (payload) =>
    GET(
      APIRoutes.apiGetClinicalReport.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getDailyReport: IGetDailyReportApi = async (payload) =>
    GET(
      APIRoutes.apiGetDailyReport
        .replace("{clinic_id}", payload.clinic_id?.toString())
        .replace("{daily_report_id}", payload.daily_report_id?.toString()),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const addReadDailyReport: IReadDailyReportApi = async (payload) =>
    PUT(
      APIRoutes.apiAddReadDailyReport
        .replace("{clinic_id}", payload.clinic_id?.toString())
        .replace("{daily_report_id}", payload.daily_report_id?.toString()),
      { ...payload },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getRiskReportAPI: IGetRiskReportAPI = async (payload) =>
    GET(
      payload.token
        ? APIRoutes.apiGetRiskReportPublicRoute
            .replace("{clinic_id}", payload.clinic_id?.toString())
            .replace("{date}", payload.date)
        : APIRoutes.apiGetRiskReport
            .replace("{clinic_id}", payload.clinic_id?.toString())
            .replace("{date}", payload.date),
      {
        token: payload.token,
      },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getReadmitRadarAPI: IGetReadmitRadarAPI = async (payload) =>
    GET(
      payload.token
        ? APIRoutes.apiGetReadmitRadarPublicRoute.replace(
            "{clinic_id}",
            payload.clinic_id?.toString()
          )
        : APIRoutes.apiGetReadmitRadar.replace(
            "{clinic_id}",
            payload.clinic_id?.toString()
          ),
      { date: payload.date, token: payload.token },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getRiskReportPreferenceAPI: IGetRiskReportPreferenceAPI = async (
    payload
  ) =>
    GET(
      payload.token
        ? APIRoutes.apiGetRiskReportClinicPreferencePublicRoute.replace(
            "{clinic_id}",
            payload.clinic_id?.toString()
          )
        : APIRoutes.apiGetRiskReportClinicPreference.replace(
            "{clinic_id}",
            payload.clinic_id?.toString()
          ),
      {
        token: payload.token,
      },
      {
        Authorization: `Bearer ${await getAuthenticationToken(payload.token)}`,
      }
    );

  const getRiskReportListAPI: IGetRiskReportListAPI = async (payload) =>
    GET(
      APIRoutes.apiGetRiskReportList.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getReadmitRadarMostCriticalAPI: IGetReadmitRadarAPI = async (payload) =>
    GET(
      APIRoutes.apiGetReAdmitRadatMostCritical.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      { date: payload.date, floor_ids: payload.floorIds },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const putAckRiskReport: IPutAckRiskReportAPI = async (payload) =>
    PUT(
      APIRoutes.apiAckRiskReport
        .replace("{clinic_id}", payload.clinic_id.toString())
        .replace("{idt_report_id}", payload.idt_report_id.toString()),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    getDailyReportList,
    getDailyReport,
    addReadDailyReport,

    getRiskReportAPI,
    getReadmitRadarAPI,
    getRiskReportPreferenceAPI,
    getRiskReportListAPI,
    getReadmitRadarMostCriticalAPI,
    putAckRiskReport,
  };
};
